<template>
  <div>
    <v-card dark style="border-radius:10px;">
      <v-form ref="form" v-model="valid">
        <v-layout wrap row justify-space-between class="pa-3">
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>District :</v-flex>
              <v-flex>
                <v-autocomplete
                  :loading="isLoadingDistrict"
                  v-model="data_search.district_id[0]"
                  item-text="district_name_th"
                  item-value="district_id"
                  :items="districtList"
                  color="black"
                  hide-details
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Status :</v-flex>
              <v-flex>
                <v-select
                  v-model="data_search.status_id"
                  item-text="text"
                  item-value="value"
                  :items="status_list"
                  color="black"
                  hide-details
                  :rules="[(v) => !!v || 'store is required']"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Start :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%;"
                >
                  <v-text-field
                    slot="activator"
                    prepend-icon="event"
                    hide-details
                    readonly
                    color="black"
                    v-model="data_search.date_start"
                    :rules="[(v) => !!v || 'name is required']"
                  ></v-text-field>
                  <v-date-picker
                    v-model="data_search.date_start"
                    color="#333"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>End :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%"
                >
                  <v-text-field
                    slot="activator"
                    prepend-icon="event"
                    hide-details
                    readonly
                    color="black"
                    v-model="data_search.date_end"
                    :rules="[(v) => !!v || 'name is required']"
                  ></v-text-field>
                  <v-date-picker
                    v-model="data_search.date_end"
                    color="#333"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 style="display:flex;justify-content:center">
            <v-btn icon large @click="initialize()">
              <div class="pt-2 text-xs-center search-btn">
                <v-progress-circular
                  indeterminate
                  color="black"
                  v-if="is_loading_report"
                ></v-progress-circular>
                <v-icon large color="black" v-else>search</v-icon>
              </div>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="report_list"
      :pagination.sync="pagination"
      :loading="is_loading_report"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ report_list.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-center">{{ props.item.order_code }}</td>
        <td class="text-xs-center">{{ props.item.order_base_code }}</td>
        <td class="text-xs-center">{{ props.item.order_date }}</td>
        <td class="text-xs-center">{{ props.item.order_time }}</td>
        <td class="text-xs-right">
          {{
            props.item.order_price
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.order_status == 7 ? "Cancel" : "Completed" }}
        </td>
        <td class="text-xs-center">
          <a
            :href="props.item.order_customer_receipt"
            target="_blank"
            style="text-decoration:none;"
          >
            <v-btn small color="#3498db" class="white--text"
              >Print to customer</v-btn
            >
          </a>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="is_loading_report == false" class="text-xs-center">
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    districtList: [
      {
        district_id: 0,
        district_name_th: "ทุกอำเภอ",
        district_name_en: "All district",
      },
    ],
    is_loading_report: false,
    valid: true,
    data_search: {
      district_id: [0],
    },
    search: "",
    loading_message: "black",
    promotionDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "num",
      },
      {
        text: "Order code",
        align: "center",
        value: "order_code",
        sortable: false,
      },
      {
        text: "Order ref.",
        align: "center",
        value: "order_code",
        sortable: false,
      },
      {
        text: "Date Order",
        align: "center",
        value: "order_datetime",
        sortable: false,
      },
      {
        text: "Time Order",
        align: "center",
        value: "order_datetime",
        sortable: false,
      },
      {
        text: "Price",
        align: "center",
        value: "price",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Customer receipt",
        align: "center",
        value: "cus_receipt",
        sortable: false,
      },
    ],
    receipts: [
      {
        order_code: "WE3OTSRC0QM1",
        price: 350,
        order_datetime: "2019-06-13 - 10:59 น.",
        status: "Complete",
        cus_receipt: "",
        store_receipt: "",
      },
    ],
    status_list: [{ text: "Complete", value: 6 }, { text: "Cancel", value: 7 }],
    menu1: false,
    menu2: false,
    isLoadingDistrict: false,
  }),
  computed: {
    ...mapState({
      report_list: (state) => state.fetchReportMessenger.report_list,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  methods: {
    ...mapActions({
      fetchDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async fetchDistrictList() {
      this.isLoadingDistrict = true;
      let province = this.provinceData.find(
        (val) =>
          val.province_name_en.replace(/ /g, "").toLowerCase() ===
          this.provinceNameEn.toLowerCase()
      );
      let districtByProvince = await this.fetchDistrictCore(
        province.province_id
      );
      this.districtList = [...this.districtList, ...districtByProvince];
      this.isLoadingDistrict = false;
    },
    async initialize() {
      if (this.$refs.form.validate()) {
        this.is_loading_report = true;
        if (this.data_search.district_id[0] == 0) {
          await this.$store.dispatch(
            "fetchReportMessenger/getReportList",
            this.data_search
          );
        } else {
          await this.$store.dispatch(
            "fetchReportMessenger/fetchOrderReceiptByDistrict",
            this.data_search
          );
        }

        this.is_loading_report = false;
      }
    },
  },
  async created() {
    this.$store.commit("fetchReportMessenger/getReportList", []);
    this.fetchDistrictList();
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
  padding: 0 10px;
}

@media screen and (max-width: 662px) {
  .search__input {
    margin-bottom: 10px;
  }
}
</style>
